import {BaseModel} from './base.model';

export class UserStatusModel extends BaseModel {
  id: string;
  name: string;
  icon: string;
  isDefault: boolean;
}
